<template>
  <div class="pc_container">
    <div class="category">
      <h2 class="title">{{ title }}</h2>
      <router-link :to="{ name: moreUrl }" class="more">{{ $t('_a._gd') }}</router-link>
    </div>
    <ul class="list drama_list">
      <!--[-->
      <li class="item" v-for="(item, i) in videoList" :key="i">
        <router-link :to="{ name: 'video', query: { code: item.code } }">
          <div class="hover_wrap">
            <img :src="item.img" class="img" />
            <div class="hover">
              <p class="title">{{ item.title }}</p>
              <p class="desc">{{ item.content }}</p>
              <button class="play">{{ $t('_a._bf') }}</button>
            </div>
          </div>
          <h3 class="title">{{ item.title }}</h3>
        </router-link>
      </li>
    </ul>
  </div>

  <!-- 标签 -->
  <!-- <div class="home-ads-container" style="height: auto !important">
    <ins class="adsbygoogle tag01">
      <div id="aswift_1_host" class="tag02">
        <div class="tag03">
          <div class="goog-rtopics tag04">Discover more</div>
          <div class="google-anno-skip google-anno-sc tag05" v-for="i in 10" :key="i">
            <svg viewBox="0 -960 960 960" width="16px" height="16px" style="fill: rgb(26, 115, 232)">
              <path d="m456-200 174-340H510v-220L330-420h126v220Zm24 120q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"></path>
            </svg>
            <span>Popcorn and movie snacks</span>
          </div>
        </div>
      </div>
    </ins>
  </div> -->
</template>

<script>
export default {
  name: 'ItemVue',
  props: {
    title: {
      type: String,
      default: ''
    },
    cateId: {
      type: Number,
      default: 0
    },
    moreUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      videoList: []
    }
  },
  watch: {
    cateId(o, n) {
      console.log(o, n)
      this.getVideoList()
    }
  },
  created() {
    this.$nextTick(function () {
      this.getVideoList()
    })
  },
  methods: {
    getVideoList() {
      let that = this
      //热门视频
      this.$api.video
        .getVideoList({
          page: 1,
          cate_id: this.cateId,
          size: 12
        })
        .then((res) => {
          that.videoList = res.data
        })
    }
  }
}
</script>

<style></style>
